import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord, requirePermission } from '@/app/guards';
import { CustomerPage, customerQuery } from '@/features/customers';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/customers/$customerId')({
  staticData: { crumb: 'nav.customers', crumbTo: '/customers' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'customer.view', 'Customers'),
  loader: async ({ context, params }) => {
    const c = await ensureRecord(
      context.queryClient.query({ ...customerQuery(params.customerId), staleTime: 'static' }),
    );
    return { crumb: c.name };
  },
  notFoundComponent: function RecordNotFound() {
    const { customerId } = Route.useParams();
    return <NotFoundView reference={customerId} />;
  },
  component: function Customer() {
    const { customerId } = Route.useParams();
    return <CustomerPage customerId={customerId} />;
  },
});
